var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('topbar'),(!_vm.sidebar.hide)?_c('sidebar',{staticClass:"sidebar-container"}):_vm._e(),_c('div',{staticClass:"main-container",class:{ sidebarHide: _vm.sidebar.hide }},[_c('app-main'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }